import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyleSheet, View, Image } from "react-native";
import { Formik, FormikHelpers } from "formik";
import { LoginUserType } from "../../../types";
import { loginProcess } from "../../../actions";
import WhiteBottomButton from "../../../components/Buttons/WhiteBottomButton";
import { getYupLoginForm, defaultLoginFormValues } from "../../../utils";
import Spinner from "../../../components/Spinner";
import Title from "../../../components/Login/Title";
import ValidationError from "../../../components/Login/ValidationError";
import { authenticationSelector } from "../../../selectors";
import { LocaleContext } from "../../../contexts";
import ErrorModal from "../../ErrorModal";
import Inputs from "./Inputs";

interface FormValues {
  telephone: string;
  password: string;
  telephoneField?: string;
}

const Login: React.FC = () => {
  const { t, locale } = useContext(LocaleContext);

  const dispatch = useDispatch();
  const authenticationData = useSelector(authenticationSelector);
  const { authenticating, loginUserError } = authenticationData;

  const handleSubmitForm = (
    values: FormValues,
    { setSubmitting }: FormikHelpers<FormValues>,
  ) => {
    const { telephoneField, ...dispatchValues } = values;
    dispatch(loginProcess(dispatchValues as LoginUserType));
    setSubmitting(false);
  };

  return (
    <View style={styles.container}>
      <ErrorModal />
      <Image
        source={require("@/assets/logo.png")}
        style={styles.logoContainer}
      />
      <Title title={t("loginScreen.signInButton").toUpperCase()} />
      <Formik<FormValues>
        initialValues={defaultLoginFormValues}
        onSubmit={handleSubmitForm}
        validationSchema={() => getYupLoginForm(locale)}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          setFieldTouched,
          touched,
          errors,
          isValid,
        }) => (
          <form>
            <Inputs
              errors={{
                telephone: errors.telephone || "",
                password: errors.password || "",
              }}
              touched={{
                telephone: !!touched.telephone,
                password: !!touched.password,
              }}
              setFieldTouched={setFieldTouched}
              handleChange={handleChange}
              values={{
                telephone: values.telephone,
                password: values.password,
              }}
              submitForm={() => isValid && handleSubmit()}
            />
            <ValidationError error={loginUserError || null} />
            <View style={styles.buttonContainer}>
              {authenticating ? (
                <Spinner theme="dark" size="large" />
              ) : (
                <WhiteBottomButton
                  buttonText={t("loginScreen.signInButton")}
                  onPress={() => {
                    if (isValid) handleSubmit();
                  }}
                />
              )}
            </View>
          </form>
        )}
      </Formik>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 20,
    paddingHorizontal: "10%",
  },
  buttonContainer: {
    marginTop: 20,
  },
  logoContainer: {
    flex: 0,
    alignSelf: "center",
  },
});

export default Login;
